export const DEFAULT_SKIP = false;

export const DEFAULT_RELATED_SUB_CATEGORY_IDS: number[] = [];

export const DEFAULT_INSPIRE_DELIVERY_IDS_SAVED: string[] = [];

export const DEFAULT_SHOULD_HIDE_SAVED_DELIVERIES = false;

export const DEFAULT_MIXPANEL_RECOMMENDATIONS_ENABLED = false;
